import { getSubStepValues } from '#models/general/steps';
import { FIVE_NUMBERS_REGEX } from '#utils/string/regex';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { SPIRIT_SET_UP_FIELDS, SPIRIT_SUBSTEPS_IDS } from './constants';

export const getSpiritSetUpFields = ({ values, errors }) => {
  const getSpiritSetUpValues = getSubStepValues(SPIRIT_SUBSTEPS_IDS.SPIRIT_SCREEN_SET_UP, values, errors);
  return [
    {
      ...getSpiritSetUpValues(SPIRIT_SET_UP_FIELDS.SPIRIT_RUN_DATE_AND_TIME),
      Component: Input,
      type: 'datetime-local'
    },
    {
      ...getSpiritSetUpValues(SPIRIT_SET_UP_FIELDS.PERIOD_ID),
      Component: Input,
      disabled: true
    },
    {
      ...getSpiritSetUpValues(SPIRIT_SET_UP_FIELDS.MASH_ID),
      Component: Input,
      disabled: true
    },
    {
      ...getSpiritSetUpValues(SPIRIT_SET_UP_FIELDS.WASH_ID),
      Component: Input,
      disabled: true
    },
    {
      ...getSpiritSetUpValues(SPIRIT_SET_UP_FIELDS.LWFR_VOLUME),
      Component: Input,
      needsRegex: true,
      customRegex: FIVE_NUMBERS_REGEX,
      measure: MEASURE_TYPES.LITRES
    }
  ];
};
